module.exports = __webpack_public_path__ + "static/media/ReceiptNew.ec42ab75.svg";